module.exports = __webpack_public_path__ + "static/repository-open-graph-template-0b8ad7942d8c1a70295a9c7b0b2e58e3.png";